var enfermos = [
      require('@/assets/enf-1.jpg'),
      require('@/assets/enf-2.jpg'),
      require('@/assets/enf-3.jpg'),
      require('@/assets/enf-4.jpg')
    ]
var sanos = [
      require('@/assets/san-1.jpeg'),
      require('@/assets/san-2.jpeg'),
      require('@/assets/san-3.jpeg'),
      require('@/assets/san-4.jpg')
    ]

var buenos = [
	"Contento",
	"Hermoso",
	"Precioso",
	"Entusiasmo",
	"Excelente",
	"Glorioso",
	"Placer",
	"Feliz"
	]

var malos = [
	"Horrible",
	"Espantoso",
	"Odio",
	"Pena",
	"Egoísmo",
	"Veneno",
	"Asco",
	"Sucio"
	]

export function getPart(num,total){
	let output = {
        current: num,
        total: total        
      }
	switch(num){
		//Standard Part 1
		case 1:
			output.base = enfermos.concat(sanos)
			output.serie = [6,2,3,8,3,5,1,6,8,5,7,3,7,1,6,2,4,7,8,5,1,4,2,4]
			output.options = [{
					            keyboard: "E",
					            value: ["","Sano"],
					            valid: [5,6,7,8]
					          },
					          {
					            keyboard: "I",
					            value: ["","Enfermo"],
					            valid: [1,2,3,4]
					          }]
		break
		//Standard Part 2
		case 2:
			output.base = buenos.concat(malos)
			output.serie = [12,11,7,16,4,5,6,13,12,10,14,8,14,6,3,6,10,12,1,9,16,8,15,13,3,4,10,3,11,15,5,4,16,1,13,8,2,7,14,9,2,7,1,5,11,15,2,9]
			output.options = [{
					            keyboard: "E",
					            value: ["Malo",""],
					            valid: [9,10,11,12,13,14,15,16]
					          },
					          {
					            keyboard: "I",
					            value: ["Bueno",""],
					            valid: [1,2,3,4,5,6,7,8]
					          }]
		break
		//Standard Part 3
		case 3:
			output.base = enfermos.concat(sanos).concat(buenos).concat(malos)
			output.serie = [7,17,15,1,21,5,8,4,5,22,18,11,2,8,13,19,18,1,24,22,2,6,12,6,12,10,9,4,5,3,16,7,4,7,14,20,14,24,1,8,9,2,23,17,6,13,6,16,3,8,11,23,7,5,2,20,3,10,21,15,4,19,1,3]
			output.options = [{
					            keyboard: "E",
					            value: ["Malo","Sano"],
					            valid: [5,6,7,8,17,18,19,20,21,22,23,24]
					          },
					          {
					            keyboard: "I",
					            value: ["Bueno","Enfermo"],
					            valid: [1,2,3,4,9,10,11,12,13,14,15,16]
					          }]
		break
		//Standard Part 4
		case 4:
			output.base = enfermos.concat(sanos).concat(buenos).concat(malos)
			output.serie = [2,12,20,1,14,5,9,1,11,6,3,1,7,8,24,4,22,13,8,24,23,6,2,8,4,5,1,13,7,4,5,10,18,17,6,16,10,3,2,14,2,15,20,17,3,11,19,7,23,21,15,5,9,7,4,18,21,6,3,19,8,16,22,12]
			output.options = [{
					            keyboard: "E",
					            value: ["Malo","Sano"],
					            valid: [5,6,7,8,17,18,19,20,21,22,23,24]
					          },
					          {
					            keyboard: "I",
					            value: ["Bueno","Enfermo"],
					            valid: [1,2,3,4,9,10,11,12,13,14,15,16]
					          }]
		break
		//Standard Part 5
		case 5:
			output.base = enfermos.concat(sanos)
			output.serie = [8,4,2,3,6,8,1,6,2,8,1,7,6,8,5,4,5,7,3,2,1,4,3,7]
			output.options = [{
					            keyboard: "E",
					            value: ["","Enfermo"],
					            valid: [1,2,3,4]
					          },
					          {
					            keyboard: "I",
					            value: ["","Sano"],
					            valid: [5,6,7,8]
					          }]
		break
		//Standard Part 6
		case 6:
			output.base = enfermos.concat(sanos).concat(buenos).concat(malos)
			output.serie = [6,16,3,4,1,15,13,6,11,8,22,3,11,2,7,12,5,22,5,21,14,17,23,21,4,14,9,19,18,23,2,6,8,24,2,12,7,8,13,3,5,19,20,16,9,2,7,4,5,3,15,6,18,1,17,7,10,24,4,8,20,10,1,1]
			output.options = [{
					            keyboard: "E",
					            value: ["Malo","Enfermo"],
					            valid: [1,2,3,4,17,18,19,20,21,22,23,24]
					          },
					          {
					            keyboard: "I",
					            value: ["Bueno","Sano"],
					            valid: [5,6,7,8,9,10,11,12,13,14,15,16]
					          }]
		break
		//Standard Part 7
		case 7:
			output.base = enfermos.concat(sanos).concat(buenos).concat(malos)
			output.serie = [1,12,16,17,6,7,8,23,20,2,8,7,5,16,7,1,3,21,5,24,11,23,17,22,9,2,3,4,13,5,19,4,15,3,12,9,14,4,13,6,10,20,5,15,11,6,18,7,2,3,10,18,21,1,19,8,14,2,4,6,22,1,24,21]
			output.options = [{
					            keyboard: "E",
					            value: ["Malo","Enfermo"],
					            valid: [1,2,3,4,17,18,19,20,21,22,23,24]
					          },
					          {
					            keyboard: "I",
					            value: ["Bueno","Sano"],
					            valid: [5,6,7,8,9,10,11,12,13,14,15,16]
					          }]
		break
	}
	return output

}	